import { Outlet } from 'react-router-dom'
import { SidebarProvider, useSidebar } from '../contexts/SidebarContext.js'
import Sidebar from './Sidebar.js'
import Header from './Header.js'

const LayoutContent = () => {
  const { isCollapsed } = useSidebar()
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />
      <div 
        className="flex flex-col transition-all duration-300"
        style={{ marginLeft: isCollapsed ? '64px' : '320px' }}
      >
        <Header />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

const Layout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  )
}

export default Layout
